import {
  Card, CardContent, Typography, Skeleton, Alert, Stack, Box,
} from '@mui/material';
import { useUsage } from '../hooks/useUsage';
import { UsageChart } from './UsageChart';

export function UsageCard() {
  const { data, isLoading, isError, error } = useUsage(30);
  const total = data?.reduce((sum, r) => sum + r.count, 0) ?? 0;

  return (
    <Card>
      <CardContent sx={{ p: 4 }}>
        <Typography variant="h3" sx={{ mb: 3 }}>Usage — last 30 days</Typography>
        {isLoading && <Skeleton variant="rectangular" height={260} />}
        {isError && (
          <Alert severity="error" sx={{ borderRadius: 0 }}>
            {(error as Error).message || 'Could not load usage'}
          </Alert>
        )}
        {data && (
          <Stack spacing={2}>
            <Stack direction="row" spacing={1} alignItems="baseline">
              <Typography sx={{ fontFamily: 'Fraunces Variable', fontSize: '3rem', lineHeight: 1, fontWeight: 400 }}>
                {total}
              </Typography>
              <Typography variant="body2" sx={{ color: 'var(--ink-muted)' }}>
                billable {total === 1 ? 'call' : 'calls'} (cache hits don't count)
              </Typography>
            </Stack>
            <UsageChart data={data} />
            {total === 0 && (
              <Box sx={{ color: 'var(--ink-muted)', fontSize: '0.875rem' }}>
                No usage yet — try the curl example on the landing page.
              </Box>
            )}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}
